var React = require('react');

function Replay (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23 20.011v8.978l8.336-4.489L23 20.011zm-3-1.674c0-1.513 1.616-2.478 2.948-1.76l11.446 6.162c1.402.755 1.402 2.767 0 3.522l-11.446 6.163C21.616 33.14 20 32.176 20 30.663V18.337z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M26.5 7c-8.776 0-16.043 6.46-17.306 14.884l4.095-2.205a1.5 1.5 0 111.422 2.642l-6.5 3.5a1.5 1.5 0 01-1.82-.312l-5-5.5a1.5 1.5 0 112.219-2.018l2.695 2.965C7.985 11.323 16.387 4 26.5 4 37.822 4 47 13.178 47 24.5S37.822 45 26.5 45a20.441 20.441 0 01-14.566-6.075 1.5 1.5 0 112.132-2.11A17.441 17.441 0 0026.5 42C36.165 42 44 34.165 44 24.5S36.165 7 26.5 7z","key":1})]);
}

Replay.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Replay;

Replay.default = Replay;
